var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8191 29.6124C40.995 27.8184 41.5824 26.4254 41.5518 24.9099C40.9022 22.5284 39.7263 20.3632 37.962 18.5989C28.5894 9.22627 15.1638 9.22627 5.7902 18.5999C4.02685 20.3632 2.85098 22.5284 2.20132 24.9099C2.44819 26.8904 3.31595 28.4987 4.30435 29.7359L12.967 26.766C13.3067 25.9307 13.6779 25.3126 13.8329 24.6621C13.6158 23.5799 13.2445 22.7131 12.5958 21.6931C17.9165 16.9906 25.9907 17.0221 31.2808 21.8166C30.8167 22.5906 30.4455 23.4556 30.1671 24.4152C30.3211 25.2505 30.4455 25.8686 30.7861 26.5191L39.8191 29.6124Z",
    fill: "#DB364F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDecline);
export default __webpack_public_path__ + "static/media/icon-decline.08731819e824322cd071759d951bbd8d.svg";
export { ForwardRef as ReactComponent };